import PropTypes from "prop-types";
import React from "react";

// import FormDropdown from "../../components/form/FormDropdown";
import FormButton from "../../components/form/FormButton";
import FormColorPicker from "../../components/form/FormColorPicker";
import FormTextField from "../../components/form/FormTextField";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import swatchColorOptions from "../../constants/colorOptions";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import userInputValidators from "../../utils/userInputValidators";

const SettingsColorDetailView = props => {
  const isIos = preprocessorQuery.isIos();
  const c = props.selectedItem ? props.colors.byId.get(props.selectedItem) : null;
  if (!c) {
    return <div />;
  }

  // TODO: Add Color Selector
  return (
    <div>
      <ModalGroup>
        <ModalRow>
          <ModalField label="Name" flex={4}>
            <FormTextField
              value={c.label}
              onChange={label => props.onLabelChange(c.id, label)}
              validator={userInputValidators.noEmpty}
            />
          </ModalField>
          <ModalField label="Color" flex={1}>
            <FormColorPicker
              value={c.swatchColor}
              options={swatchColorOptions}
              id="settingsColorTabColorPicker"
              onChange={color => props.onColorChange(c.id, color)}
              title="Color"
              backText="Settings"
            />
          </ModalField>
        </ModalRow>
      </ModalGroup>
      {isIos && props.canDelete ? (
        <ModalGroup>
          <ModalRow>
            <div className="settingsDetailDeleteButton">
              <FormButton destructive={true} label="Delete" onClick={props.onDeleteClick} />
            </div>
          </ModalRow>
        </ModalGroup>
      ) : null}
    </div>
  );
};

SettingsColorDetailView.propTypes = {
  colors: PropTypeShapes.denormalisedTypeDefinitionsIdList.isRequired,
  selectedItem: PropTypes.string,
  onLabelChange: PropTypes.func.isRequired,
  onColorChange: PropTypes.func.isRequired,
  canDelete: PropTypes.bool,
  onDeleteClick: PropTypes.func
};

export default SettingsColorDetailView;
